import { render } from "./TermsService.vue?vue&type=template&id=f5d8cfb0"
import script from "./TermsService.vue?vue&type=script&lang=js"
export * from "./TermsService.vue?vue&type=script&lang=js"

import "./TermsService.vue?vue&type=style&index=0&id=f5d8cfb0&lang=scss"

import exportComponent from "/home/blissfulapps/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__